import $ from 'jquery';
import { Cloudinary } from '@cloudinary/url-gen';
import { fill } from '@cloudinary/url-gen/actions/resize';

$(function () {
  var cloudinary = window.cloudinary;
  if ($.fn.cloudinary_upload_widget === undefined) {
    // So that feature specs don't fail when cloudinary isn't loaded
    return;
  }

  const cloudinaryConfig = {
    apiKey: window.env?.CLOUDINARY_API_KEY,
    cloudName: window.env?.CLOUDINARY_CLOUD_NAME,
  };

  cloudinary.setAPIKey(cloudinaryConfig.apiKey);
  cloudinary.setCloudName(cloudinaryConfig.cloudName);

  const cld = new Cloudinary({
    cloud: {
      cloudName: cloudinaryConfig.cloudName,
    },
    url: {
      secure: true,
    },
  });

  const generateSignature = function (callback, params_to_sign) {
    $.ajax({
      url: '/api/v1/cloudinary_signatures',
      type: 'POST',
      dataType: 'text',
      data: { signing_params: params_to_sign },
      complete: function () {
        console.log('complete');
      },
      success: function (response, _textStatus, _xhr) {
        const { signature } = JSON.parse(response);
        callback(signature);
      },
      error: function (xhr, status, error) {
        console.log(xhr, status, error);
      },
    });
  };

  function uploadOptions(additionalOptions) {
    return $.extend(
      {
        uploadSignature: generateSignature,
        thumbnails: 'do-not-show',
        sources: ['local'],
        clientAllowedFormats: ['png', 'jpeg'],
      },
      additionalOptions
    );
  }

  $('#profile-upload-widget-opener').click(function () {
    cloudinary.openUploadWidget(
      uploadOptions({ uploadPreset: 'rytykijt', folder: 'user_photos' }),
      function (error, result) {
        if (!error && result && result.event === 'success') {
          const img = cld.image(result.info.public_id).resize(fill(160, 160));
          const url = img.toURL();
          $('#image').attr('value', url);
          $('img.profile-image').attr('src', url);
          $('.js-default-copy').addClass('hidden');
          $('.js-reset-default-image').removeClass('hidden');
        }
      }
    );
  });

  $('.js-tag-image-widget-opener').click(function () {
    cloudinary.openUploadWidget(
      uploadOptions({ uploadPreset: 'rytykijt', folder: 'tag_image' }),
      function (error, result) {
        if (!error && result && result.event === 'success') {
          const img = cld.image(result.info.public_id).resize(fill(160, 160));
          const url = img.toURL();
          $('.js-tag-image-val').val(url);
          $('img.js-tag-image-src').attr('src', url);
        }
      }
    );
  });

  $('.js-custom-link-image-widget-opener').click(function () {
    var _this = this;
    cloudinary.openUploadWidget(
      uploadOptions({
        uploadPreset: 'iheuyxtg',
        folder: 'custom_link_image',
        minImageHeight: 100,
        minImageWidth: 180,
        maxImageHeight: 300,
        maxImageWidth: 340,
      }),
      function (error, result) {
        if (!error && result && result.event === 'success') {
          const url = result.info.secure_url;
          const $formGroup = $(_this).parents('.js-custom-link-image-group');
          $formGroup.find('.js-custom-link-image').val(url);
          $formGroup.find('img').attr('src', url);
        }
      }
    );
  });

  $('#branding-upload-widget-opener').click(function () {
    cloudinary.openUploadWidget(
      uploadOptions({ uploadPreset: 'rytykijt', folder: 'user_photos' }),
      function (error, result) {
        if (!error && result && result.event === 'success') {
          const img = cld.image(result.info.public_id).resize(fill(160, 160));
          const url = img.toURL();
          $('#default_profile_picture').attr('value', url);
          $('img.branding-default-profile-picture').attr('src', url);
        }
      }
    );
  });

  $('#translation-upload-widget-opener').click(function () {
    cloudinary.openUploadWidget(
      uploadOptions({ uploadPreset: 'rytykijt', folder: 'user_photos' }),
      function (error, result) {
        if (!error && result && result.event === 'success') {
          const img = cld.image(result.info.public_id).resize(fill(160, 160));
          const url = img.toURL();
          $('.js-default-profile-picture svg').hide();
          $('#default_profile_picture').attr('value', url);
          $('img.translation-default-profile-picture').attr('src', url);
        }
      }
    );
  });

  $('.company-upload-widget-opener').click(function () {
    var _this = this;
    cloudinary.openUploadWidget(
      uploadOptions({ uploadPreset: 'ekalmd3l', folder: 'company_logos' }),
      function (error, result) {
        if (!error && result && result.event === 'success') {
          const url = result.info.secure_url;
          const $formGroup = $(_this).parents('.company-upload-image-group');
          $formGroup.find('.company-upload-image').val(url);
          $formGroup.find('img.logo-image-upload').attr('src', url);
        }
      }
    );
  });
});
